import { render, staticRenderFns } from "./ModuleMockTest.vue?vue&type=template&id=0186fb99&"
import script from "./ModuleMockTest.vue?vue&type=script&lang=js&"
export * from "./ModuleMockTest.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports